import {
  fetchCourseList,
  addCourse,
  updateCourse,
  deleteCourse,
  listSkill,
  addSkill,
  updateSkill,
  deleteSkill,
  listKeySummary,
  addKeySummary,
  updateKeySummary,
  deleteKeySummary,
  deleteSyllabus,
  updateSyllabus,
  addSyllabus,
  listSyllabus,
  fetchWeekList,
  fetchDayList,
  addSyllabusDetail,
  addWeeklySyllabus,
  listSyllabusDetail,
} from "services/courseService";

import {
  fetchAllCourses,
  fetchSingleCourse,
  courseSuccessMsg,
  courseErrorMsg,
  setCourseLoader,
  setPagination,
  setSkillLoader,
  fetchAllSkills,
  skillErrorMsg,
  skillSuccessMsg,
  keySummaryErrorMsg,
  fetchAllKeySummary,
  setKeySummaryLoader,
  keySummarySuccessMsg,
  syllabusErrorMsg,
  setSyllabusLoader,
  syllabusSuccessMsg,
  fetchAllSyllabus,
  weekErrorMsg,
  setWeekLoader,
  fetchAllWeeks,
  setDayLoader,
  dayErrorMsg,
  fetchAllDays,
  syllabusDetailErrorMsg,
  syllabusDetailSuccessMsg,
  setSyllabusDetailLoader,
  weeklySyllabusErrorMsg,
  weeklySyllabusSuccessMsg,
  setWeeklySyllabusLoader,
  setSyllabusDetailData,
} from "./reducer";
import { AppDispatch } from "store";

export const fetchCourses = (data: any) => async (dispatch: any) => {
  dispatch(setCourseLoader(true));
  try {
    const response = await fetchCourseList(data);

    if (response.success) {
      dispatch(setPagination(response.data.pagination));

      if (data.course_id && data.course_id !== 0) {
        dispatch(fetchSingleCourse(response));
      } else {
        dispatch(fetchAllCourses(response));
      }
    } else {
      dispatch(
        courseErrorMsg({
          message: response.message || "Failed to fetch courses",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong";
    dispatch(courseErrorMsg({ message: errorMessage, id: Date.now() }));
  } finally {
    dispatch(setCourseLoader(false));
  }
};


export const createCourse = (courseData: any) => async (dispatch: any) => {
  dispatch(setCourseLoader(true));
  try {
    const response = await addCourse(courseData);
    if (response.success) {
      dispatch(
        courseSuccessMsg({
          message: response.message || "Course added successfully",
          id: Date.now(),
        })
      );
      return response;
    } else {
      dispatch(
        courseErrorMsg({
          message: response.message || "Failed to add course",
          id: Date.now(),
        })
      );
    }
    return response;
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong";
    dispatch(courseErrorMsg({ message: errorMessage, id: Date.now() }));
    return null;
  } finally {
    dispatch(setCourseLoader(false));
  }
};

  export const updatecourse = (course_id: number, courseData: any) => async (dispatch: any) => {
    dispatch(setCourseLoader(true));
    try {
      const response = await updateCourse(course_id, courseData);
      if (response.success) {
        dispatch(
          courseSuccessMsg({
            message: response.message || "Course updated successfully",
            id: Date.now(),
          })
        );
      } else {
        dispatch(
          courseErrorMsg({
            message: response.message || "Failed to update course",
            id: Date.now(),
          })
        );
      }
    } catch (error: any) {
      const errorMessage =
        error?.message || error?.response?.data?.message || "Something went wrong";
      dispatch(courseErrorMsg({ message: errorMessage, id: Date.now() }));
    } finally {
      dispatch(setCourseLoader(false));
    }
  };

export const deletecourse = (course_id: number) => async (dispatch: any) => {
  dispatch(setCourseLoader(true));
  try {
    const response = await deleteCourse(course_id);
    if (response.success) {
      dispatch(
        courseSuccessMsg({
          message: response.message || "Course deleted successfully",
          id: Date.now(),
        })
      );
    } else {
      dispatch(
        courseErrorMsg({
          message: response.message || "Failed to delete course",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    const errorMessage =
      error?.message || error?.response?.data?.message || "Something went wrong";
    dispatch(courseErrorMsg({ message: errorMessage, id: Date.now() }));
  } finally {
    dispatch(setCourseLoader(false));
  }
};

export const fetchSkills = (course_id: number) => async (dispatch: any) => {
  dispatch(setSkillLoader(true));
  try {
    const response = await listSkill(course_id);

    if (response.success) {
      dispatch(fetchAllSkills(response.data)); 
    } else {
      dispatch(
        skillErrorMsg({
          message: response.message || "Failed to fetch skills",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    const errorMessage =
      error?.message ||
      error?.response?.data?.message ||
      "Something went wrong";
    dispatch(skillErrorMsg({ message: errorMessage, id: Date.now() }));
  } finally {
    dispatch(setSkillLoader(false));
  }
};

export const createSkill = (skillData: any) => async (dispatch: AppDispatch) => {
  dispatch(setSkillLoader(true));
  try {
    const response = await addSkill(skillData);

    if (response.success) {
      dispatch(
        skillSuccessMsg({
          message: response.message || "Skill added successfully",
          id: Date.now(),
        })
      );

      dispatch(fetchSkills(skillData.course_id));
    } else {
      dispatch(
        skillErrorMsg({
          message: response.message || "Failed to add skill",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    const errorMessage =
      error?.message ||
      error?.response?.data?.message ||
      "Something went wrong";
    dispatch(skillErrorMsg({ message: errorMessage, id: Date.now() }));
  } finally {
    dispatch(setSkillLoader(false));
  }
};

export const updateskill =
  (skill_id: number, skillData: any) => async (dispatch: any) => {
    dispatch(setSkillLoader(true));
    try {
      const response = await updateSkill(skill_id, skillData);

      if (response.success) {
        dispatch(
          skillSuccessMsg({
            message: response.message || "Skill updated successfully",
            id: Date.now(),
          })
        );

        // Refresh after update
        dispatch(fetchSkills(skillData.course_id));
      } else {
        dispatch(
          skillErrorMsg({
            message: response.message || "Failed to update skill",
            id: Date.now(),
          })
        );
      }
    } catch (error: any) {
      const errorMessage =
        error?.message ||
        error?.response?.data?.message ||
        "Something went wrong";
      dispatch(skillErrorMsg({ message: errorMessage, id: Date.now() }));
    } finally {
      dispatch(setSkillLoader(false));
    }
  };

  export const deleteskill =
  (skill_id: number, course_id: number) => async (dispatch: any) => {
    dispatch(setSkillLoader(true));
    try {
      const response = await deleteSkill(skill_id);

      if (response.success) {
        dispatch(
          skillSuccessMsg({
            message: response.message || "Skill deleted successfully",
            id: Date.now(),
          })
        );

        // Refresh after delete
        dispatch(fetchSkills(course_id));
      } else {
        dispatch(
          skillErrorMsg({
            message: response.message || "Failed to delete skill",
            id: Date.now(),
          })
        );
      }
    } catch (error: any) {
      const errorMessage =
        error?.message ||
        error?.response?.data?.message ||
        "Something went wrong";
      dispatch(skillErrorMsg({ message: errorMessage, id: Date.now() }));
    } finally {
      dispatch(setSkillLoader(false));
    }
  };

  export const fetchKeySummary = (course_id: number) => async (dispatch: any) => {
    dispatch(setKeySummaryLoader(true));
    try {
      const response = await listKeySummary(course_id);

      if (response.success) {
        dispatch(fetchAllKeySummary(response.data));  // ONLY array
      } else {
        dispatch(
          keySummaryErrorMsg({
            message: response.message || "Failed to fetch key summary",
            id: Date.now(),
          })
        );
      }
    } catch (error: any) {
      const errorMessage =
        error?.message ||
        error?.response?.data?.message ||
        "Something went wrong";

      dispatch(
        keySummaryErrorMsg({
          message: errorMessage,
          id: Date.now(),
        })
      );
    } finally {
      dispatch(setKeySummaryLoader(false));
    }
  };

  export const createKeySummary = (summaryData: any) => async (dispatch: any) => {
    dispatch(setKeySummaryLoader(true));
    try {
      const response = await addKeySummary(summaryData);

      if (response.success) {
        dispatch(
          keySummarySuccessMsg({
            message: response.message || "Key Summary added successfully",
            id: Date.now(),
          })
        );

        // Refresh list
        dispatch(fetchKeySummary(summaryData.course_id));
      } else {
        dispatch(
          keySummaryErrorMsg({
            message: response.message || "Failed to add key summary",
            id: Date.now(),
          })
        );
      }
    } catch (error: any) {
      const errorMessage =
        error?.message ||
        error?.response?.data?.message ||
        "Something went wrong";

      dispatch(
        keySummaryErrorMsg({
          message: errorMessage,
          id: Date.now(),
        })
      );
    } finally {
      dispatch(setKeySummaryLoader(false));
    }
  };

  export const updateKeySummaryData =
  (keysummary_id: number, summaryData: any) => async (dispatch: any) => {
    dispatch(setKeySummaryLoader(true));
    try {
      const response = await updateKeySummary(keysummary_id, summaryData);

      if (response.success) {
        dispatch(
          keySummarySuccessMsg({
            message: response.message || "Key Summary updated successfully",
            id: Date.now(),
          })
        );

        dispatch(fetchKeySummary(summaryData.course_id));
      } else {
        dispatch(
          keySummaryErrorMsg({
            message: response.message || "Failed to update key summary",
            id: Date.now(),
          })
        );
      }
    } catch (error: any) {
      const errorMessage =
        error?.message ||
        error?.response?.data?.message ||
        "Something went wrong";

      dispatch(
        keySummaryErrorMsg({
          message: errorMessage,
          id: Date.now(),
        })
      );
    } finally {
      dispatch(setKeySummaryLoader(false));
    }
  };

  export const deleteKeySummaryData =
  (keysummary_id: number, course_id: number) => async (dispatch: any) => {
    dispatch(setKeySummaryLoader(true));
    try {
      const response = await deleteKeySummary(keysummary_id);

      if (response.success) {
        dispatch(
          keySummarySuccessMsg({
            message: response.message || "Key Summary deleted successfully",
            id: Date.now(),
          })
        );

        dispatch(fetchKeySummary(course_id));
      } else {
        dispatch(
          keySummaryErrorMsg({
            message: response.message || "Failed to delete key summary",
            id: Date.now(),
          })
        );
      }
    } catch (error: any) {
      const errorMessage =
        error?.message ||
        error?.response?.data?.message ||
        "Something went wrong";

      dispatch(
        keySummaryErrorMsg({
          message: errorMessage,
          id: Date.now(),
        })
      );
    } finally {
      dispatch(setKeySummaryLoader(false));
    }
  };

  export const fetchSyllabus = (course_id: number) => async (dispatch: any) => {
  dispatch(setSyllabusLoader(true));

  try {
    const response = await listSyllabus(course_id);

    if (response.success) {
      dispatch(fetchAllSyllabus(response.data)); 
    } else {
      dispatch(
        syllabusErrorMsg({
          message: response.message || "Failed to fetch syllabus",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      syllabusErrorMsg({
        message:
          error?.message ||
          error?.response?.data?.message ||
          "Something went wrong",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setSyllabusLoader(false));
  }
};

export const fetchSyllabusDetailList =
(syllabus_id: number) => async (dispatch: any) => {
  dispatch(setSyllabusDetailLoader(true));
  try {
    const response = await listSyllabusDetail(syllabus_id);

    if (response.success) {
      dispatch(setSyllabusDetailData(response.data || []));
    } else {
      dispatch(
        syllabusDetailErrorMsg({
          message: response.message || "Failed to fetch syllabus detail",
          id: Date.now(),
        })
      );
    }
    return response;
  } catch (error: any) {
    dispatch(
      syllabusDetailErrorMsg({
        message:
          error?.message ||
          error?.response?.data?.message ||
          "Something went wrong",
        id: Date.now(),
      })
    );
    return null;
  } finally {
    dispatch(setSyllabusDetailLoader(false));
  }
};

export const createSyllabus = (syllabusData: any) => async (dispatch: any) => {
  dispatch(setSyllabusLoader(true));

  try {
    const response = await addSyllabus(syllabusData);

    if (response.success) {
      dispatch(
        syllabusSuccessMsg({
          message:
            response.message || "Syllabus added successfully",
          id: Date.now(),
        })
      );

      // Refresh list
      dispatch(fetchSyllabus(syllabusData.course_id));
    } else {
      dispatch(
        syllabusErrorMsg({
          message: response.message || "Failed to add syllabus",
          id: Date.now(),
        })
      );
    }
    return response;
  } catch (error: any) {
    dispatch(
      syllabusErrorMsg({
        message:
          error?.message ||
          error?.response?.data?.message ||
          "Something went wrong",
        id: Date.now(),
      })
    );
    return null;
  } finally {
    dispatch(setSyllabusLoader(false));
  }
};

export const updateSyllabusData =
  (syllabus_id: number, syllabusData: any) => async (dispatch: any) => {
    dispatch(setSyllabusLoader(true));

    try {
      const response = await updateSyllabus(syllabus_id, syllabusData);

      if (response.success) {
        dispatch(
          syllabusSuccessMsg({
            message:
              response.message || "Syllabus updated successfully",
            id: Date.now(),
          })
        );

        // Refresh list
        dispatch(fetchSyllabus(syllabusData.course_id));
      } else {
        dispatch(
          syllabusErrorMsg({
            message: response.message || "Failed to update syllabus",
            id: Date.now(),
          })
        );
      }
    } catch (error: any) {
      dispatch(
        syllabusErrorMsg({
          message:
            error?.message ||
            error?.response?.data?.message ||
            "Something went wrong",
          id: Date.now(),
        })
      );
    } finally {
      dispatch(setSyllabusLoader(false));
    }
  };

export const deleteSyllabusData =
  (syllabus_id: number, course_id: number) => async (dispatch: any) => {
    dispatch(setSyllabusLoader(true));

    try {
      const response = await deleteSyllabus(syllabus_id);

      if (response.success) {
        dispatch(
          syllabusSuccessMsg({
            message:
              response.message || "Syllabus deleted successfully",
            id: Date.now(),
          })
        );

        // Refresh list
        dispatch(fetchSyllabus(course_id));
      } else {
        dispatch(
          syllabusErrorMsg({
            message: response.message || "Failed to delete syllabus",
            id: Date.now(),
          })
        );
      }
    } catch (error: any) {
      dispatch(
        syllabusErrorMsg({
          message:
            error?.message ||
            error?.response?.data?.message ||
            "Something went wrong",
          id: Date.now(),
        })
      );
    } finally {
      dispatch(setSyllabusLoader(false));
    }
  };

export const addSyllabusDetailThunk =
  (detailData: any) => async (dispatch: any) => {
    dispatch(setSyllabusDetailLoader(true));

    try {
      const response = await addSyllabusDetail(detailData);

      if (response.success) {
        dispatch(
          syllabusDetailSuccessMsg({
            message: response.message || "Syllabus detail saved successfully",
            id: Date.now(),
          })
        );
      } else {
        dispatch(
          syllabusDetailErrorMsg({
            message: response.message || "Failed to save syllabus detail",
            id: Date.now(),
          })
        );
      }
      return response;
    } catch (error: any) {
      dispatch(
        syllabusDetailErrorMsg({
          message:
            error?.message ||
            error?.response?.data?.message ||
            "Something went wrong",
          id: Date.now(),
        })
      );
      return null;
    } finally {
      dispatch(setSyllabusDetailLoader(false));
    }
  };

export const addWeeklySyllabusThunk =
  (weeklyData: any) => async (dispatch: any) => {
    dispatch(setWeeklySyllabusLoader(true));

    try {
      const response = await addWeeklySyllabus(weeklyData);

      if (response.success) {
        dispatch(
          weeklySyllabusSuccessMsg({
            message: response.message || "Weekly syllabus saved successfully",
            id: Date.now(),
          })
        );
      } else {
        dispatch(
          weeklySyllabusErrorMsg({
            message: response.message || "Failed to save weekly syllabus",
            id: Date.now(),
          })
        );
      }
      return response;
    } catch (error: any) {
      dispatch(
        weeklySyllabusErrorMsg({
          message:
            error?.message ||
            error?.response?.data?.message ||
            "Something went wrong",
          id: Date.now(),
        })
      );
      return null;
    } finally {
      dispatch(setWeeklySyllabusLoader(false));
    }
  };
  export const fetchWeeks = () => async (dispatch: any) => {
  dispatch(setWeekLoader(true));

  try {
    const response = await fetchWeekList();

    if (response.success) {
      dispatch(fetchAllWeeks(response.data)); 
    } else {
      dispatch(
        weekErrorMsg({
          message: response.message || "Failed to fetch weeks",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      weekErrorMsg({
        message:
          error?.message ||
          error?.response?.data?.message ||
          "Something went wrong",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setWeekLoader(false));
  }
};
export const fetchDays = () => async (dispatch: any) => {
  dispatch(setDayLoader(true));

  try {
    const response = await fetchDayList();

    if (response.success) {
      dispatch(fetchAllDays(response.data)); 
    } else {
      dispatch(
        dayErrorMsg({
          message: response.message || "Failed to fetch days",
          id: Date.now(),
        })
      );
    }
  } catch (error: any) {
    dispatch(
      dayErrorMsg({
        message:
          error?.message ||
          error?.response?.data?.message ||
          "Something went wrong",
        id: Date.now(),
      })
    );
  } finally {
    dispatch(setDayLoader(false));
  }
};
